/**
 * The one error type every request rejects with.
 */
export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly retryAfterSec?: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }

  /** The session is gone or was never there. Distinct from "not allowed". */
  get unauthenticated(): boolean {
    return this.status === 401;
  }
}
